<template>
  <div>
    <div ref="scripts"></div>

    <script type="application/javascript" defer>
  window.Paddle.Setup({ vendor: 112461 });
    </script>

    <mdb-container class="mt-5 content-area mt-5">
      <PageHeader text="Buy Tokens"></PageHeader>

      <div class="d-flex justify-content-center mt-5" v-if="isLoading">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="mt-5 d-flex justify-content-center row" v-if="!isLoading">
        <TokensCard productId="601075" tokensCount="100" price="$ 2.49"></TokensCard>
        <TokensCard productId="604231" tokensCount="500" price="$ 9.99" isBest="true"></TokensCard>
        <TokensCard productId="604247" tokensCount="1500" price="$ 24.99"></TokensCard>
        <TokensCard productId="604251" tokensCount="5000" price="$ 89.99"></TokensCard>
      </div>
    </mdb-container>
  </div>
</template>

<script>
import { mdbContainer } from "mdbvue";
import PageHeader from "../../components/PageHeader";
import TokensCard from "@/components/TokensCard";
export default {
  name: "BuyTokens",
  components: {
    mdbContainer,
    PageHeader,
    TokensCard
  },
  computed: {
    isLoading: function() {
      return this.$store.getters["ui/isLoading"];
    }
  },
  methods: {},
  data() {
    return {
      showAlert: false
    };
  },
  created: function() {},
  mounted: function() {}
};
</script>
